module.exports = __webpack_public_path__ + "static/img/img_profile_lala.5641aea.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/images/img_profile_lala.jpg
// module id = 556
// module chunks = 1